export default __webpack_public_path__ + "static/images/tradeup-logo.c0debe10.png";